import { formatNumber } from '../../../utils/numberformatter';
import { pick } from '../pick';

export const CARGO_RATIO_LABELS = [
  '50% : 50%',
  '75% : 25%',
  '25% : 75%',
  '100% : 0%',
  '0% : 100%',
];

export const getCargoRatioKey = cargoRatioId => {
  const numericValue = Number(cargoRatioId);
  const resolved = Number.isFinite(numericValue) ? numericValue : cargoRatioId;
  return String(resolved);
};

export const formatParcelSizes = (quantityTargets = [], unitLabel = 'MT') =>
  quantityTargets.map(
    target => `${formatNumber(target.quantity)} ${unitLabel}`
  );

export const filterSelectionsForParcel = (selections, quantityFks) => {
  const fkSet = new Set(quantityFks.map(String));
  return selections.filter(selection =>
    fkSet.has(
      String(pick(selection, 'quantityInformationFK', 'QuantityInformationFK'))
    )
  );
};
